import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolsModule } from '../tools/tools.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImportMaterialModule } from '../material.module';

import { BreadCrumbsComponent } from './breadcrumbs';


@NgModule({
    declarations: [
        BreadCrumbsComponent
    ],
    imports: [
        CommonModule,
        FormsModule, ReactiveFormsModule,
        ToolsModule,
        ImportMaterialModule,
        // AngularEditorModule
    ],
    exports: [
        BreadCrumbsComponent
    ],
    providers: [
    ],
    entryComponents: [
        BreadCrumbsComponent
    ]
})
export class NavModule {

    // constructor(private injector: Injector) {
    //     const explorer = createCustomElement(FileExplorer, {injector: this.injector});
    
    //     customElements.define('ess-file-explorer', explorer);
    //     console.log("Registered element (with distinct selector!!!!!!) " + "ess-file-explorer");

    // }
}